import React, { createContext, useContext, useState, useEffect } from "react";
import {
  getCookie,
  setCookie,
  deleteCookie,
} from "../utility/cookies/cookieUtils";

const CookieContext = createContext();

export const CookieProvider = ({ children }) => {
  const [consent, setConsent] = useState({
    necessary: true,
    analytics: false,
    marketing: false,
  });
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const savedConsent = getCookie("cookieConsent");
    if (savedConsent) {
      setConsent(JSON.parse(savedConsent));
      setShowBanner(false);
    } else {
      setShowBanner(true);
    }
  }, []);

  const acceptCookies = (all) => {
    const newConsent = {
      necessary: true,
      analytics: all,
      marketing: false,
    };
    setConsent(newConsent);
    setCookie("cookieConsent", JSON.stringify(newConsent), 365);
    setShowBanner(false);
  };

  const rejectCookies = () => {
    setConsent({ necessary: true, analytics: false, marketing: false });
    deleteCookie("cookieConsent");
    setShowBanner(false);
  };

  // For compatibility, keep updateConsent for direct updates
  const updateConsent = (newConsent) => {
    setConsent(newConsent);
    setCookie("cookieConsent", JSON.stringify(newConsent), 365);
    setShowBanner(false);
  };

  return (
    <CookieContext.Provider
      value={{
        consent,
        updateConsent,
        showBanner,
        acceptCookies,
        rejectCookies,
      }}
    >
      {children}
    </CookieContext.Provider>
  );
};

export const useCookieConsent = () => {
  const context = useContext(CookieContext);
  if (!context) {
    throw new Error("useCookieConsent must be used within a CookieProvider");
  }
  return context;
};

export { CookieContext };
